export default __webpack_public_path__ + "static/media/empty-profile-icon.bb9ff26e.svg";